import { Box, Heading, Text, Link as ChakraLink, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import React, { FormEvent, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import InputText from '../../../parts/InputText';
import InputRequiredRef from '../../../../interfaces/InputRef';
import ButtonSubmit from '../../../parts/ButtonSubmit';
import InputPESEL from '../../../parts/InputPESEL';
import RequiredMark from '../../../parts/RequiredMark';
import ErrorMessage from '../../../parts/ErrorMessage';
import { RegistrationForm } from './RegistrationForm';
import InputPhone from '../../../parts/InputPhone';
import InputPostCode from '../../../parts/InputPostCode';
import InputCheckbox from '../../../parts/InputCheckbox';
import InputCheckboxDate from '../../../parts/InputCheckboxDate';
import InputBaseRef from '../../../../interfaces/InputBaseRef';


const Register: React.FC = () => {
    const navigate = useNavigate();

    const { state } = useLocation();

    const firstNameRef = useRef<InputRequiredRef>();
    const surnameRef = useRef<InputRequiredRef>();
    const familySurnameRef = useRef<InputRequiredRef>();
    const numberPESELRef = useRef<InputRequiredRef>();
    const motherNameRef = useRef<InputRequiredRef>();
    const motherSurnameRef = useRef<InputRequiredRef>();
    const fatherNameRef = useRef<InputRequiredRef>();
    const RODOAcceptRef = useRef<InputBaseRef<Date>>();
    const streetRef = useRef<InputRequiredRef>();
    const streetNumberRef = useRef<InputRequiredRef>();
    const flatNumberRef = useRef<InputRequiredRef>();
    const postCodeRef = useRef<InputRequiredRef>();
    const cityRef = useRef<InputRequiredRef>();
    const phoneNumberRef = useRef<InputRequiredRef>();
    
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [signUpError, setSignUpError] = useState<string>("");
    const [showDialogFatherQuestion, setShowDialogFatherQuestion] = useState(false);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        if (formValidation()) {
            const fatherName: string = fatherNameRef.current!.value();
            if (fatherName == "") {
                setShowDialogFatherQuestion(true);
                return;
            }
            submitForm();
        } else {
            showError();
        }
    }

    const handleDialogFatherResponse = (value: boolean) => {
        setShowDialogFatherQuestion(false);
        if (value) {
            if (formValidation()) {
                submitForm();
            } else {
                showError()
            }
        }
    }

    const formValidation = (): boolean | undefined => {
        return firstNameRef.current?.validate() &&
            surnameRef.current?.validate() &&
            familySurnameRef.current?.validate() &&
            numberPESELRef.current?.validate() &&
            motherNameRef.current?.validate() &&
            motherSurnameRef.current?.validate() &&
            fatherNameRef.current?.validate() &&
            phoneNumberRef.current?.validate() &&
            streetRef.current?.validate() &&
            streetNumberRef.current?.validate() &&
            flatNumberRef.current?.validate() &&
            postCodeRef.current?.validate() &&
            cityRef.current?.validate() &&
            RODOAcceptRef.current?.validate()
    }

    const showError = () => {
        console.error(
            firstNameRef.current?.validate() + " " +
            surnameRef.current?.validate() + " " +
            familySurnameRef.current?.validate() + " " +
            numberPESELRef.current?.validate() + " " +
            motherNameRef.current?.validate() + " " +
            motherSurnameRef.current?.validate() + " " +
            fatherNameRef.current?.validate() + " " +
            phoneNumberRef.current?.validate() + " " +
            streetRef.current?.validate() + " " +
            streetNumberRef.current?.validate() + " " +
            flatNumberRef.current?.validate() + " " +
            postCodeRef.current?.validate() + " " +
            cityRef.current?.validate()
        )
    }

    const submitForm = () => {
        const name: string = firstNameRef.current!.value();
        const surname: string = surnameRef.current!.value();
        const familySurname: string = familySurnameRef.current!.value();
        const phoneNumber: string = phoneNumberRef.current!.value();
        const pesel: string = numberPESELRef.current!.value();
        const motherName: string = motherNameRef.current!.value();
        const motherSurname: string = motherSurnameRef.current!.value();
        var fatherName: string = fatherNameRef.current!.value();

        var street: string = streetRef.current!.value();
        var streetNumber: string = streetNumberRef.current!.value();
        var flatNumber: string = flatNumberRef.current!.value();
        var postCode: string = postCodeRef.current!.value();
        var city: string = cityRef.current!.value();
        var rodoAccept: Date | undefined = RODOAcceptRef.current?.value()

        setSubmitting(true);
        setSignUpError("");
        if (fatherName == "") { fatherName = "brak danych"; }

        const registrationForm = new RegistrationForm(
            name,
            surname,
            familySurname,
            phoneNumber,
            pesel,
            motherName,
            motherSurname,
            fatherName,
            street,
            streetNumber,
            flatNumber,
            postCode,
            city,
            rodoAccept?.toISOString() ?? "",
        )
        navigate("/register-summary", { state: { registrationForm: registrationForm } });
    };

    var date = new Date()
    date.setFullYear(date.getFullYear() - 18);

    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/forest.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                padding="5"
                margin="8"
                borderRadius="md"
                boxShadow="lg"
                textAlign="center"
                width="2xl"

                marginTop="120px"
                marginBottom="20px"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                >
                    Rejestracja
                </Heading>
                <form onSubmit={handleSubmit}>
                    <Box
                        padding="3"
                    >
                        <Box
                            display='flex'
                            flexDirection='column'
                            gap="8"
                        >
                            <Box>
                                <Heading
                                    padding="3"
                                    as="h3"
                                    size="sm"
                                >
                                    Dane personalne
                                </Heading>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 10px 1fr"
                                    gap="10px"
                                >
                                    <InputText
                                        ref={firstNameRef}
                                        label={'Imię'}
                                        maxLength={128}
                                        placeholderText={'Jan'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.name ?? ''}
                                    />
                                    <Box />
                                    <InputText
                                        ref={surnameRef}
                                        label={'Nazwisko'}
                                        maxLength={128}
                                        placeholderText={'Kowalski'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.surname ?? ''}
                                    />
                                    <InputText
                                        ref={familySurnameRef}
                                        label={'Nazwisko rodowe'}
                                        maxLength={128}
                                        placeholderText={'Nowak'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.familySurname ?? ''}
                                    />
                                    <Box />
                                    <InputPESEL
                                        ref={numberPESELRef}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.pesel ?? ''}
                                    />
                                    <InputPhone
                                        ref={phoneNumberRef}
                                        label={'Telefon'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.phoneName ?? ''}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <Box
                                    display='flex'
                                    flexDirection='row'
                                    justifyContent='space-around'
                                >
                                    <Heading
                                        padding="3"
                                        as="h3"
                                        size="sm"
                                    >
                                        Dane matki
                                    </Heading>
                                    <Heading
                                        padding="3"
                                        as="h3"
                                        size="sm"
                                    >
                                        Dane ojca
                                    </Heading>
                                </Box>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 10px 1fr"
                                    gap="10px"
                                >
                                    <InputText
                                        ref={motherNameRef}
                                        label={'Imię matki'}
                                        maxLength={128}
                                        placeholderText={'Anna'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.motherName ?? ''}
                                    />
                                    <Box/>
                                    <InputText
                                        ref={fatherNameRef}
                                        label={'Imię ojca'}
                                        maxLength={128}
                                        placeholderText={'Jan'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.fatherName ?? ''}
                                    />
                                    <InputText
                                        ref={motherSurnameRef}
                                        label={'Nazwisko rodowe matki'}
                                        maxLength={128}
                                        placeholderText={'Kowalska'}
                                        isRequired={false}
                                        initValue={state?.registrationForm?.motherSurname ?? ''}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <Heading
                                    padding="3"
                                    as="h3"
                                    size="sm"
                                >
                                    Dane korespondencyjne
                                </Heading>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 10px 1fr"
                                    gap="10px"
                                >
                                    <InputPostCode
                                        ref={postCodeRef}
                                        label={'Kod pocztowy'}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.postCode ?? ''}
                                    />
                                    <Box/>
                                    <InputText
                                        ref={cityRef}
                                        maxLength={256}
                                        label={'Miejscowość'}
                                        placeholderText={''}
                                        isRequired={true}
                                        initValue={state?.registrationForm?.city ?? ''}
                                    />
                                </Box>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 10px 1fr 10px 1fr"
                                    gap="10px"
                                >
                                    <InputText
                                        ref={streetRef}
                                        label={'Ulica'}
                                        maxLength={256}
                                        isRequired={true}
                                        placeholderText={''}
                                        initValue={state?.registrationForm?.street ?? ''}
                                    />
                                    <Box/>
                                    <InputText
                                        ref={streetNumberRef}
                                        maxLength={30}
                                        label={'Numer domu'}
                                        isRequired={true}
                                        placeholderText={''}
                                        initValue={state?.registrationForm?.buildingNumber ?? ''}
                                    />
                                    <Box/>
                                    <InputText
                                        ref={flatNumberRef}
                                        maxLength={30}
                                        label={'Numer lokalu'}
                                        placeholderText={''}
                                        isRequired={false}
                                        initValue={state?.registrationForm?.flatNumber ?? ''}
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <InputCheckboxDate
                                    ref={RODOAcceptRef}
                                    label={"Zgoda Rodo"}
                                    text={"Akceptuje postanowienia <u><a href=\"/rodo\" target=\"_blank\"></Box>RODO</a></u>"}
                                    isRequired={true}
                                    initValue={undefined} />
                            </Box>
                        </Box>
                        <RequiredMark withDescription />
                        <ErrorMessage text={signUpError} />
                        <ButtonSubmit text={'Zarejestruj'} isSubmitting={submitting} />
                    </Box>
                </form>
                {/*<Text*/}
                {/*    mt={8}*/}
                {/*>*/}
                {/*    Posiadałeś konto w baza.zhr.pl?{" "}*/}
                {/*    <ChakraLink as={Link} to="/migrate"*/}
                {/*        color="brand.500"*/}
                {/*        fontWeight="bold"*/}
                {/*    >*/}
                {/*        Migruj dane ze starego konta!*/}
                {/*    </ChakraLink>*/}
                {/*</Text>*/}
                <AlertDialogFatherName show={showDialogFatherQuestion} close={handleDialogFatherResponse} />
            </Box>
        </Box>
    );
};


function AlertDialogFatherName({ show, close }: { show: boolean, close: (value: boolean) => void }) {//
    const cancelRef = React.useRef(null)

    return (
        <>
            <Modal
                isOpen={show}
                onClose={() => close(false)}
                closeOnOverlayClick={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        Czy jesteś pewien, że nie możesz podać imienia ojca?
                    </ModalBody>

                    <ModalFooter>
                        <Button ref={cancelRef} onClick={() => close(false)}>
                            Wróć
                        </Button>
                        <Button colorScheme='brand' onClick={() => close(true)} ml={3}>
                            Imię ojca jest nieznane
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default Register;
